import React from 'react'

import * as config from 'styles/tailwind.config'

export interface SvgProps {
  primary?: boolean
  secondary?: boolean
  tertiary?: boolean
  danger?: boolean
  light?: boolean
  dark?: boolean
  size?: number
}

class Svg<T extends SvgProps> extends React.Component<T, {}> {
  public static defaultProps = {
    size: 24,
  }

  public getColor() {
    if (this.props.primary) {
      return config.theme.colors.brand.primary
    }
    if (this.props.danger) {
      return config.theme.colors.red
    }
    if (this.props.light) {
      return config.theme.colors['gray-300']
    }
    if (this.props.dark) {
      return config.theme.colors['gray-400']
    }
    return config.theme.colors.black
  }
}

export default Svg
